import React from 'react';
import { useLocale } from '@gov-nx/core/service';
import { filter, hasProperty, pipe } from '@gov-nx/core/types';
import { useProfilROSContextInstance } from '@gov-nx/module/page';
import { CopyButton, Tile, Tiles } from '@gov-nx/ui/web';
import { pageRouteResolver } from '@gov-nx/web';

export const PersonInvolmentListView = () => {
	const { personInvolvementData, code } = useProfilROSContextInstance();
	const { t } = useLocale(code);

	if (!personInvolvementData.length) return null;

	return (
		<section>
			<h1 className="text-headline-s! text-(--text-secondary)">
				{t('nadpis.angazovanost')}
			</h1>
			<Tiles>
				{personInvolvementData.map((person) => (
					<Tile
						key={person.ico}
						name={person.nazevSpolecnosti}
						headlineLink={true}
						to={pageRouteResolver('profil.ros.detail', {
							ico: person.ico,
							agendaCode: person.agenda?.kod,
						})}
						icon={{ name: 'chevron-right', type: 'components' }}>
						<div className="flex flex-col gap-(--spacing-s) text-(--text-secondary)">
							<div className="flex flex-wrap items-center gap-1">
								<span className="inline-block mr-1!">
									{t('zaznam.role.popis')}
								</span>
								{pipe(
									person.angazovaneOsoby,
									filter(hasProperty('role')),
									(involvementPerson) => (
										<strong>
											{involvementPerson.length
												? involvementPerson
														.map((person) =>
															t(`zaznam.role.hodnota.${person.role}`)
														)
														.join(', ')
												: '-'}
										</strong>
									)
								)}
							</div>

							{person.ico ? (
								<div className="flex items-center gap-1">
									<span className="inline-block mr-1!">{t('zaznam.dic')}</span>
									<strong>{'CZ' + person.ico}</strong>
									<CopyButton
										label={'akce.kopirovat-ico' + ' ' + person.ico}
										value={'CZ' + person.ico}
									/>
								</div>
							) : null}

							{person.sidloSpolecnosti?.adresaText ? (
								<div className="flex items-center gap-1">
									<span className="inline-block mr-1!">
										{t('zaznam.sidlo')}
									</span>
									<strong>{person.sidloSpolecnosti?.adresaText}</strong>
								</div>
							) : null}
						</div>
					</Tile>
				))}
			</Tiles>
		</section>
	);
};
